export default __webpack_public_path__ + "static/media/newSet3-3-min.ec5af7d1.png";